import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_UNIT_RECORDS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_UNIT_RECORD:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_UNIT_RECORD:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_UNIT_RECORD_BULK:
      return { ...state, ..._.mapKeys(action.payload, "Id") };
    case type.EDIT_UNIT_RECORD:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_UNIT_RECORD:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
